module.exports = __webpack_public_path__ + "img/f84ead9c701b474bb33ce67966bdc283.png";